module.exports = __webpack_public_path__ + "static/example-01-square-edd0977d19989298dd271d4012947170.png";